/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
import {
  assign,
  createMachine,
  DoneInvokeEvent,
  interpret,
  Interpreter,
} from 'xstate-v4'
import { NearbyRepositoryFetch } from './NearbyRepositoryFetch'
import { NearbyCampsite, SearchFilters } from './schemas'

export interface NearbyContext {
  campsites: NearbyCampsite[]
  isDated?: boolean
  searchFilters: SearchFilters
  slug: string
  langCode: string
}

const nearbyRepository = new NearbyRepositoryFetch()

export function returnNearbyCampsitesMachine() {
  return createMachine<NearbyContext>(
    {
      context: {
        campsites: [],
        searchFilters: {},
        slug: '',
        langCode: 'en-gb',
      },
      initial: 'fetching',
      states: {
        fetching: {
          invoke: {
            src: 'fetch',
            onDone: {
              target: 'finished',
              actions: [
                assign({
                  campsites: (_, { data }) => data.results,
                  isDated: (_, { data }) => data.isDated,
                }),
              ],
            },
            onError: {
              target: 'error',
              actions: (_, event) => handleFetchError(event),
            },
          },
        },
        finished: {
          type: 'final',
        },
        error: {
          type: 'final',
        },
      },
    },
    {
      services: {
        fetch: (c) => nearbyRepository.get(c.slug, c.searchFilters, c.langCode),
      },
    },
  )
}

// Custom error handler function
function handleFetchError(event: DoneInvokeEvent<any>) {
  if (event.data && event.data.type === 'error.platform.fetch') {
    // Log or handle network errors differently
    console.error('Network error occurred:', event)
  } else {
    // Handle other types of errors
    console.error('NearbyCampsite Error', event)
  }
}

export type NearbyCampsitesMachineInterpreter = Interpreter<NearbyContext>

export function getNearbyCampsitesMachine(context: Partial<NearbyContext>) {
  const machine = returnNearbyCampsitesMachine()
  return interpret(machine.withContext({ ...machine.context, ...context }))
}
